document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.gallery-section').forEach(function (section) {
    var lightbox = document.querySelector('[data-gallery-lightbox]');
    if (!lightbox) return;

    var triggers = section.querySelectorAll('[data-gallery-trigger]');
    var track = lightbox.querySelector('[data-gallery-track]');
    var slides = lightbox.querySelectorAll('.gallery-lightbox__slide');
    var counter = lightbox.querySelector('[data-gallery-counter]');
    var closeBtns = lightbox.querySelectorAll('[data-gallery-close]');
    var prevBtn = lightbox.querySelector('[data-gallery-prev]');
    var nextBtn = lightbox.querySelector('[data-gallery-next]');

    var total = slides.length;
    var current = 0;
    var lastFocused = null;

    function goTo(index) {
      current = (index + total) % total;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      if (counter) counter.textContent = (current + 1) + ' / ' + total;
    }

    function open(index) {
      lastFocused = document.activeElement;
      goTo(index);
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (closeBtns[0]) closeBtns[0].focus();
      document.addEventListener('keydown', onKeydown);
    }

    function close() {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused) lastFocused.focus();
    }

    function onKeydown(e) {
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') goTo(current - 1);
      if (e.key === 'ArrowRight') goTo(current + 1);
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var index = parseInt(trigger.getAttribute('data-index'), 10) || 0;
        open(index);
      });
    });

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', close);
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    // Basic swipe support
    var startX = null;
    var stage = lightbox.querySelector('.gallery-lightbox__stage');
    if (stage) {
      stage.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
      }, { passive: true });

      stage.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var diff = e.changedTouches[0].clientX - startX;
        if (Math.abs(diff) > 40) {
          diff > 0 ? goTo(current - 1) : goTo(current + 1);
        }
        startX = null;
      });
    }
  });
});
